import {
  LIST_PLURALL_CREDENTIAL_REQUEST,
  LIST_PLURALL_CREDENTIAL_SUCCESS,
  LIST_PLURALL_CREDENTIAL_ERROR,
  GET_PLURALL_CREDENTIAL_REQUEST,
  GET_PLURALL_CREDENTIAL_SUCCESS,
  GET_PLURALL_CREDENTIAL_ERROR,
  ADD_PLURALL_CREDENTIAL_REQUEST,
  ADD_PLURALL_CREDENTIAL_SUCCESS,
  ADD_PLURALL_CREDENTIAL_ERROR,
  EDIT_PLURALL_CREDENTIAL_REQUEST,
  EDIT_PLURALL_CREDENTIAL_SUCCESS,
  EDIT_PLURALL_CREDENTIAL_ERROR,
  RESET_STATE_REDUX,
  RESET_STATE_ALL_APPLICATION,
} from '../actions';

const INIT_STATE = {
  currentPlurallCredential: null,
  currentPlurallCredentialList: [],
  loading: false,
  error: '',
  success: '',
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case LIST_PLURALL_CREDENTIAL_REQUEST:
    case GET_PLURALL_CREDENTIAL_REQUEST:
    case ADD_PLURALL_CREDENTIAL_REQUEST:
    case EDIT_PLURALL_CREDENTIAL_REQUEST:
      return { ...state, loading: true, error: '', success: '' };

    case LIST_PLURALL_CREDENTIAL_SUCCESS:
      return {
        ...state,
        loading: false,
        currentPlurallCredentialList: action.payload,
      };

    case GET_PLURALL_CREDENTIAL_SUCCESS:
      return {
        ...state,
        loading: false,
        currentPlurallCredential: action.payload,
      };

    case ADD_PLURALL_CREDENTIAL_SUCCESS:
      return {
        ...state,
        loading: false,
        success: action.payload,
        currentPlurallCredentialList: [
          ...(state.currentPlurallCredentialList ?? []),
          action.payload,
        ],
      };

    case EDIT_PLURALL_CREDENTIAL_SUCCESS:
      return {
        ...state,
        loading: false,
        success: action.payload,
        currentPlurallCredentialList: (state.currentPlurallCredentialList ?? []).map(
          (item) => (item.id === action.payload.id ? action.payload : item)
        ),
        currentPlurallCredential: action.payload,
      };

    case LIST_PLURALL_CREDENTIAL_ERROR:
    case GET_PLURALL_CREDENTIAL_ERROR:
    case ADD_PLURALL_CREDENTIAL_ERROR:
    case EDIT_PLURALL_CREDENTIAL_ERROR:
      return { ...state, loading: false, error: action.payload };

    case RESET_STATE_REDUX:
    case RESET_STATE_ALL_APPLICATION:
      return { ...INIT_STATE };

    default:
      return state;
  }
};
